<ohp-title-announcer [announcement]="statusAnnouncement"></ohp-title-announcer>
<div [hidden]="!cards || !cards.length"
     class="carousel"
     [ngClass]="{'carousel--fluent': fluentRefresh}"
     @fadeIn [@.disabled]="disableAnimation"
     [attr.aria-label]="recommendedTitle"
     #carouselContainer>
    <div [ngClass]="{'list-header--carousel--motion': recommendedMotion, 'list-header list-header--carousel': !fluentRefresh, 'list-header--fluent': fluentRefresh}">
        <h3 *ngIf="cards && cards.length > 0"
            id="recommendedHeader"
            class="ms-fcl-nd"
            [ngClass]="{
                'list-header__title list-header__title--carousel': !fluentRefresh,
                'list-header__title--fluent': fluentRefresh}">{{ recommendedTitle }}</h3>
        <div *ngIf="cards && !canSwipeRecommended && !(currentCarouselPage === 0 && currentCarouselPage + cardIncrement >= cards.length)" class="carousel-nav">
            <button id="recommended-nav-left"
                    class="icon-button ms-bgc-g40-h ms-fcl-nd-h"
                    keyboardFocusTooltip
                    [ngClass]="{'icon-button--disabled ms-fcl-nta': currentCarouselPage === 0,
                                'ms-fcl-ns': currentCarouselPage !== 0,
                                'first-arrow': !fluentRefresh,
                                'icon-button--fluent': fluentRefresh}"
                    [attr.aria-label]="previousPage"
                    [title]="previousPage"
                    (focus)="onScrollFocus(true)"
                    (click)="navigateCards(-1)"
                    data-clicklog="custom"
                    [attr.aria-disabled]="currentCarouselPage === 0"
                    [tabindex]="currentCarouselPage === 0 ? -1 : 0" #recommendedNavLeft>
                <ohp-icon-font iconFontName="ChevronLeft" size="16" cssClass="carousel-nav__arrow" [ariaVisible]="true"></ohp-icon-font>
            </button>
            <button id="recommended-nav-right"
                    class="icon-button ms-bgc-g40-h ms-fcl-nd-h"
                    keyboardFocusTooltip
                    [ngClass]="{'icon-button--disabled ms-fcl-nta': currentCarouselPage + cardIncrement >= cards.length,
                                'ms-fcl-ns': currentCarouselPage + cardIncrement < cards.length,
                                'icon-button--fluent': fluentRefresh }"
                    [attr.aria-label]="nextPage"
                    [title]="nextPage"
                    (focus)="onScrollFocus(false)"
                    (click)="navigateCards(1)"
                    data-clicklog="custom"
                    [attr.aria-disabled]="currentCarouselPage + cardIncrement >= cards.length"
                    [tabindex]="currentCarouselPage + cardIncrement >= cards.length ? -1 : 0" #recommendedNavRight>
                <ohp-icon-font iconFontName="ChevronRight" size="16" cssClass="carousel-nav__arrow" [ariaVisible]="true"></ohp-icon-font>
            </button>
        </div>
    </div>
    <div [ngClass]="{'carousel--outer carousel--virtual-outer': canSwipeRecommended,
        'recommended-container__motion': recommendedMotion,
        'recommended-container__motion--suggested-actions': recommendedMotion && isSuggestedActions,
        'recommended-container__motion--hidden': motionState === 'moving',
        'recommended-container__gap': recommendedMotion || fluentRefresh }">
        <div [ngClass]="{'carousel--inner': canSwipeRecommended, 'generic-tile-container generic-tile-container--card card__content': !canSwipeRecommended && !recommendedMotion,
             'recommended-inner__motion': recommendedMotion,
             'recommended-inner__motion--suggested-actions': recommendedMotion && isSuggestedActions,
             'generic-tile-container--card--suggested-actions': !recommendedMotion && !canSwipeRecommended && isSuggestedActions}"
             (ohpResize)="updateCarouselCardData()"
             [@recommendedMotionTrigger]="{value: motionState, params: {translationParam: translateX}}"
             (@recommendedMotionTrigger.done)="recommendedMotionDone()"
             #carouselElement>
            <ng-container *ngIf="recommendedMotion">
                <div *ngFor="let item of recommendedMotionList; let i=index; trackBy: trackByIndex"
                     [ngClass]="{'carousel-card--hidden': motionState !== 'moving' && (i < currentCarouselPage),
                                 'carousel-card--display-none': motionState !== 'moving' && i > (currentCarouselPage + cardIncrement),
                                 'carousel-card-container': !isSuggestedActions,
                                 'carousel-card--peek': !isSuggestedActions && !fluentRefresh,
                                 'carousel-card--peek--fluent': isFluentRecommended,
                                 'carousel-card-container--suggested-actions': isSuggestedActions
                                }">
                    <ohp-mru-item [item]="item" [index]="i" [relativeIndex]="i" [listId]="listId" [view]="recommendedDocView" [showSharing]="showSharing" [showActivity]="showActivity" [showAnalytics]="showAnalytics" [mruAppType]="fileType" (deleteItem)="onDeleteRecommendedItem($event)"></ohp-mru-item>
                </div>
            </ng-container>
            <ng-container *ngIf="canSwipeRecommended">
                <cdk-virtual-scroll-viewport orientation="horizontal" class="virtual-scroll-cards">
                    <div *cdkVirtualFor="let item of cards; let i=index; trackBy: trackByIndex"
                        class="carousel-card-container carousel-card--virtual-touch" #virtualCard>
                        <ohp-mru-item [item]="item" [index]="i+currentCarouselPage" [relativeIndex]="i" [listId]="listId" [view]="recommendedDocView" [showSharing]="showSharing" [showActivity]="showActivity" [showAnalytics]="showAnalytics" [mruAppType]="fileType" (deleteItem)="onDeleteRecommendedItem($event)"></ohp-mru-item>
                    </div>
                </cdk-virtual-scroll-viewport>
            </ng-container>
            <ng-container *ngIf="!canSwipeRecommended && !recommendedMotion">
                <div *ngFor="let item of cards | slice:currentCarouselPage:currentCarouselPage+cardIncrement; let i=index; trackBy: trackByIndex"
                     class="carousel-card-container carousel-card--desktop">
                    <ohp-mru-item [item]="item" [index]="i+currentCarouselPage" [relativeIndex]="i" [listId]="listId" [view]="recommendedDocView" [showSharing]="showSharing" [showActivity]="showActivity" [showAnalytics]="showAnalytics" [mruAppType]="fileType" [leftAlignActionsMenu]="false" (deleteItem)="onDeleteRecommendedItem($event)"></ohp-mru-item>
                </div>
            </ng-container>
        </div>
    </div>
</div>
